import React, { useContext } from "react"
import { Rules } from "@orbital/games-frontend-library"
import GameDescription from "./GameDescription"
import {
  settings,
  GameplayCustomization,
  GeneralConditions,
  AutoRules,
} from "./CONTENT"
import { MyContext } from "../../context/createContext"
import HistoryImg from "../../lib/assets/imgs/history.png"

export default function DefaultRules() {
  const {
    ctx: {
      config,
      auth: { balance },
    },
  } = useContext(MyContext)

  return (
    <>
      <GameDescription />
      <p>
        Min Bet {config.minbet} {balance.currency}
      </p>
      <p>
        Max Bet {config.maxbet} {balance.currency}
      </p>
      <h3>Settings</h3>
      <Rules content={settings} />
      <h3>Gameplay Customization</h3>
      <Rules content={GameplayCustomization} />
      <h3>Round History Train </h3>
      <img src={HistoryImg} alt="" width="100%" />
      <p>
        You can see previous 6 Round results in the animated train displayed
        above that dynamically changes with every new round.{" "}
      </p>
      <h3>General Conditions</h3>
      <p>
        Please refer to conditions and cases that characterise the game based on
        its specifications and gameplay type
      </p>
      <Rules content={GeneralConditions} />
      <p>
        Autoplay mode will be disabled after finishing ongoing round during
        disconnection, to avoid placing bets and spending your balance without
        your supervision in case of long connection problem.
      </p>
      <p>
        In case of autocashout feature enabled game will automatically withdraw
        the specified amount that you have indicated in autoplay settings and
        you will be able to see the result in game history.
      </p>
      <p>What happens if we crash on Minimum Multipler?</p>
      <p>
        The cashout button becomes available for use when the game multiplier
        reaches or exceeds 1.01x. If the explosion happens, the stake is
        considered as lost.
      </p>

      <h3>Auto Play</h3>
      <p>
        <b>Bet Amount</b> - Input field for bet amount betted during Autoplay.
        Min value {config.minbet}
        {balance.currency} max value {config.maxbet}
        {balance.currency}
      </p>
      <p>
        <b>Cashaout At</b> - Cash indication of when to stop the autoplay round.
        Minimum default value{" "}
        {config.minbet < 1 ? "1.01" : config.minbet * 1.01} {balance.currency};{" "}
        Maximum value {config.maxbet * 5000}
        {balance.currency}.
      </p>
      <Rules content={AutoRules} />
      <p>
        <b>Cashout Minimum Value - </b>
        {config.minbet < 1
          ? "1.01 " + balance.currency + "; "
          : config.minbet * 1.01 +
            " " +
            balance.currency +
            "; You can cash out at for below amount manually but as our light speed rocket is fast the autoplay mode will only cash out you for the said number once multiplier reaches 1.01 "}
        {balance.currency}
        {". "}
        {config.minbet < 1
          ? " Bet amount below 1.01 " +
            balance.currency +
            " can be placed but from ranges " +
            config.minbet +
            " " +
            balance.currency +
            " to 1.01 " +
            balance.currency +
            " Cashout at value will be 1.01 " +
            balance.currency +
            " no matter the value. Minimum multiplier for the bet range between " +
            config.minbet +
            " " +
            balance.currency +
            " to 1.01 " +
            balance.currency +
            " does not exist as bet is Cashed out at 1.01 " +
            balance.currency +
            "."
          : ""}
      </p>
      <p>
        <b>Cashout Maximum Value </b> - {config.maxbet * 5000}{" "}
        {balance.currency}; Player can set bet amount Maximum in the amount of{" "}
        {config.maxbet} {balance.currency}. Maximum multiplier that is available
        in the game is 5000X. Thus Maximum win amount is {config.maxbet * 5000}{" "}
        {balance.currency} equal to Maximum Cashout At value.
      </p>
    </>
  )
}
